import {
  AssetGroupAdapter,
  type AssetGroupAdapterType,
} from "./AssetGroupAdapters.ts";

export const NetworkAdapter: Pick<
  AssetGroupAdapterType,
  "getList" | "getOne" | "createOne" | "updateOne" | "deleteOne"
> = {
  /**
   * a convenience method to get a list of Networks (otherwise known as a Asset Group) through the AssetGroupAdapter
   */
  getList: AssetGroupAdapter.getList,
  /**
   * a convenience method to get a single Network (otherwise known as a Asset Group) through the AssetGroupAdapter
   */
  getOne: AssetGroupAdapter.getOne,
  /**
   * a convenience method to create a Network (otherwise known as a Asset Group) through the AssetGroupAdapter
   */
  createOne: AssetGroupAdapter.createOne,
  /**
   * a convenience method to create a Network (otherwise known as a Asset Group) through the AssetGroupAdapter
   */
  updateOne: AssetGroupAdapter.updateOne,

  /**
   * a convenience method to delete a Network (otherwise known as a Asset Group) through the AssetGroupAdapter
   */
  deleteOne: AssetGroupAdapter.deleteOne,
};
